const Refreshment = (state) => state.Refreshment
const refreshmentItem = (state) => state.refreshmentItem
const listReceiptPax = (state) => state.listReceiptPax
const InfoBankPax = (state) => state.InfoBankPax
const listMealPlanInfos = (state) => state.listMealPlanInfo
const Currencies = (state) => state.Currencies
const Countrys = (state) => state.Countrys
const dataBank = (state) => state.dataBank
const MealPlanPriceTotalPax = (state) => state.MealPlanPriceTotalPax
const dataInfoBankPax = (state) => state.dataInfoBankPax
const MealPlanInfoPax = (state) => state.MealPlanInfo

export default {
  Refreshment,
  refreshmentItem,
  listReceiptPax,
  InfoBankPax,
  listMealPlanInfos,
  Currencies,
  dataBank,
  MealPlanPriceTotalPax,
  dataInfoBankPax,
  Countrys,
  MealPlanInfoPax
}
